import { useCallback } from 'react';
import { useLazyAllocation } from '../../hooks/useAllocation';
import { browserLogger } from '../../utils/loggers/browser';
import { clearVisionIntentCookie, setVisionIntentCookie } from '../../features/vision/utils';
export const VISION_BETTER_REFERRALS_EXPERIMENT_NAME = 'aa.mixer.vision_better_referrals' as const;
export const VISION_BETTER_REFERRALS_TREATMENT_VALUE = 'vision' as const;
export const VISION_BETTER_REFERRALS_CONTROL_VALUE = 'no_vision' as const;
export const VISION_BETTER_REFERRALS_CONFIG_PARAM = {
  expectedValues: [VISION_BETTER_REFERRALS_CONTROL_VALUE, VISION_BETTER_REFERRALS_TREATMENT_VALUE],
  fallbackValue: VISION_BETTER_REFERRALS_CONTROL_VALUE,
  name: VISION_BETTER_REFERRALS_EXPERIMENT_NAME
};

/**
 * Visitor-level allocation for shared Vision referrals.
 * Control continues through regular onboarding; treatment receives VFF via vision_intent.
 */
export const useVisionBetterReferralsAllocation = () => {
  const [allocateToVisionBetterReferrals] = useLazyAllocation([VISION_BETTER_REFERRALS_CONFIG_PARAM]);
  const allocateVisionBetterReferralsVisitor = useCallback(async () => {
    try {
      const {
        data,
        error
      } = await allocateToVisionBetterReferrals();
      if (error) {
        throw error;
      }
      const allocationValue = data?.visitor?.configParams?.find(p => p.name === VISION_BETTER_REFERRALS_EXPERIMENT_NAME)?.value;
      if (allocationValue === VISION_BETTER_REFERRALS_TREATMENT_VALUE) {
        setVisionIntentCookie();
      } else {
        clearVisionIntentCookie();
      }
    } catch (error) {
      clearVisionIntentCookie();
      browserLogger({
        level: 'error',
        team: 'style-inspiration',
        feature: 'vision-onboarding',
        message: 'Failed to allocate shared Vision visitor for Vision Better Referrals experiment',
        context: {
          error
        }
      });
    }
  }, [allocateToVisionBetterReferrals]);
  return {
    allocateVisionBetterReferralsVisitor
  };
};